import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import App from './App';
import { PublicRoutes } from './pages/PublicRoutes';
import { Navigate, Route, Routes } from "react-router-dom";
import ResetPassword from './components/resetPassword/ResetPassword';
import { baseUrl } from './shared/Fetch';
// import { PrivateRoutes } from './pages/PrivateRoutes';

const AppWrapper = () => {
    const [adminLogin, setAdminLogin] = useState(false);
    const [checkAdminLogin, setCheckAdminLogin] = useState(false);
    let location = useLocation();

    const AlterAdminAuth = () => {
        setAdminLogin(prev => prev = false);
        sessionStorage.removeItem('adminAuth');
    }

    useEffect(() => {
        const adminAuth = sessionStorage.getItem('adminAuth') !== undefined ? sessionStorage.getItem('adminAuth') : null;
        if (adminAuth !== null) {
            const adminAuthData = JSON.parse(sessionStorage.getItem('adminAuth') || "");
            if (adminAuthData.isAdminAuth === true) {
                setAdminLogin(true);
            };
        }
        window.scrollTo(0, 0);
    }, [location]);

    const auth = sessionStorage.getItem('auth') !== undefined ? sessionStorage.getItem('auth') : null;

    const directOtpLogin = async () => {
        if (location?.search?.split("email=")[1]) {
            const response = await fetch(
                baseUrl + "External_User_Mast/forgotpassword",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email: location?.search?.split("email=")[1] }),
                }
            );
            if (response.ok) {
                sessionStorage.setItem(
                    "resetEmail",
                    location?.search?.split("email=")[1]
                );
                
            } else  {
                let data = await response.text();
                alert(data);
                sessionStorage.removeItem("step");
                window.location.href = window.location.href.split(".com")[0]+".com/login";
            }
        }
    };
    if (location?.search?.includes("email=")) {
        // navigate("/reset-password");
        sessionStorage.setItem("step", "otp");
        directOtpLogin();
        return (
            <Routes>
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="*" element={<Navigate to={"/reset-password"} />} />
            </Routes>
        );
    }
    // console.log(auth);
    return (
        auth !== null ? <App></App > : <PublicRoutes></PublicRoutes>
    );
};

export default AppWrapper;
